// DOP-948 #2 — Gỡ widget "LẤY MÃ" của MKT bên thứ 3.
// Trước đây component nhúng script `https://tinyl.io/CIPF` (-> widget-countdown.js
// của repo traffic-user) và inject nút đỏ floating "LẤY MÃ" vào #trafficuser. Nút
// này bị lỗi đè lên header khi resize màn hình. Theo yêu cầu, gỡ hẳn phần nhúng
// script + container. Giữ lại component (render rỗng) để không phải sửa mọi nơi
// đang import; muốn bật lại chỉ cần khôi phục từ git history.
const MKTScript = () => {
  return <></>
}

export default MKTScript
